import { UserRole } from "@/types/openapi-enum";

/**
 * Get user role flags from V5 API format (string array)
 * V5 API returns roles as: ["ADMIN", "MANAGER"]
 */
export const getUserRole = (userRoles?: string[] | null | undefined) => {
  let isOwner = false;
  let isManager = false;
  let isTechnician = false;
  let isEvaluator = false;
  let isAdmin = false;

  if (!userRoles) {
    return { isOwner, isManager, isAdmin, isTechnician, isEvaluator };
  }

  userRoles.forEach((role: string) => {
    if (role === UserRole.Owner || role === UserRole.Member) isOwner = true;
    if (role === UserRole.Manager) isManager = true;
    if (role === UserRole.Admin) isAdmin = true;
    if (role === UserRole.Technician) isTechnician = true;
    // An evaluator holds exactly a technician's permissions; every gate that
    // admits `isTechnician` admits `isEvaluator` too.
    if (role === UserRole.Evaluator) isEvaluator = true;
  });

  return { isOwner, isManager, isAdmin, isTechnician, isEvaluator };
};

/**
 * Get highest priority role from V5 API format (string array)
 * V5 API returns roles as: ["ADMIN", "MANAGER"]
 */
export const getHighestRole = (roles?: string[] | null | undefined): string => {
  if (!roles || roles.length === 0) {
    return "";
  }
  const priorityOrder: string[] = [
    UserRole.Admin,
    UserRole.Manager,
    UserRole.Technician,
    UserRole.Evaluator,
    UserRole.Owner,
    UserRole.Member,
  ];
  // Create a copy to avoid mutating the original array
  const sortedRoles = [...roles].sort(
    (a, b) => priorityOrder.indexOf(a) - priorityOrder.indexOf(b),
  );
  return sortedRoles[0] || "";
};

export const getUserRoleLabel = (role: string) => {
  let label = role;
  if (!role) {
    return null;
  }
  // change owner to member on FE
  if (role === UserRole.Owner) {
    label = "MEMBER";
  }
  return label?.charAt(0).toUpperCase() + label?.slice(1).toLowerCase();
};

// `getPlaceRoleLabel` moved to `@/libs/place-role-labels` — it lives with the
// label map it reads, and shared UI in `components/` needs it (which must not
// import upward from `features/`).
